export default __webpack_public_path__ + "static/media/1630573914(1).980c6509.jpg";